import React from "react";
import useSWR from "swr";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { api, fmtDateTime, relativeTime } from "@/lib/api";
import { Skeleton, StatusPill, PriorityDot } from "@/components/Atoms";

const fetcher = (u) => api.get(u).then((r) => r.data);

export default function MgmtEscalations() {
  const { data } = useSWR("/tickets", fetcher, { refreshInterval: 10000 });
  const escalations = (data || []).filter(t => (t.priority === "P1" || t.sla_breached) && !["resolved","closed"].includes(t.status))
    .sort((a, b) => (a.sla_deadline || "").localeCompare(b.sla_deadline || ""));

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <div className="rc-title-1 flex items-center gap-2"><AlertTriangle className="text-[var(--rc-destructive)]"/> Escalation Centre</div>
          <div className="rc-callout">P1 critical &amp; SLA-breached queries, sorted by oldest deadline.</div>
        </div>
        <div className="rc-card rc-card-padded text-right">
          <div className="rc-caption uppercase tracking-wider">Live</div>
          <div className="rc-title-2 rc-tabular" style={{ color: "var(--rc-destructive)" }}>{escalations.length}</div>
        </div>
      </div>

      {!data && <Skeleton h={300}/>}

      <div className="rc-card rc-card-padded">
        {escalations.length === 0 && <div className="rc-footnote py-10 text-center">No escalations. Things are calm.</div>}
        <div className="divide-y divide-[var(--rc-line)]">
          {escalations.map(t => (
            <Link to={`/crm/tickets/${t.ticket_id}`} key={t.ticket_id} className="py-3 flex items-center gap-3 hover:bg-[var(--rc-near-white)] -mx-2 px-2 rounded-lg" data-testid={`esc-${t.ticket_id}`}>
              <PriorityDot priority={t.priority}/>
              <div className="flex-1 min-w-0">
                <div className="rc-headline truncate">{t.subject}</div>
                <div className="rc-footnote">{t.category} · SLA {fmtDateTime(t.sla_deadline)}</div>
              </div>
              <StatusPill status={t.sla_breached ? "breached" : t.status}/>
              <ChevronRight size={16} className="text-[var(--rc-grey-icon)]"/>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
